import React, { Component } from 'react';

import { RelatedEntityGrid as EntityGrid } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelInputBytes } from 'hay-core-react';
import { ModelCalendar } from 'hay-core-react';
import { ModelTempo } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import UsuarioLog               from '../../../models/UsuarioLog';
import { Usuario } from 'hay-core-react';
import Routerboard               from '../../../models/Routerboard';
import UsuarioLogTipologEnum    from '../../../enums/UsuarioLogTipologEnum';
import UsuarioLogDispositivoEnum from '../../../enums/UsuarioLogDispositivoEnum';
import UsuarioProvedorEnum      from '../../../enums/UsuarioProvedorEnum';

// ─── Esquema de campos ────────────────────────────────────────────────────────

const model = {
    usuario: {
        exibir:       'main.usuariologacesso.usuario',
        visivel:      true,
        tipo:         'relacao',
        camporelacao: 'nome',
        entidade:     'usuario.entidade',
        template:     'usuario.template',
        // Apenas usuários de classificação hotspot podem ser vinculados aos logs.
        filtro: {
            classificacao: { constraints: [{ value: 'main.usuario.classificacao.hotspot', matchMode: 'equals' }] },
        },
    },
    routerboard: {
        exibir:       'main.usuariologacesso.routerboard',
        visivel:      true,
        tipo:         'relacao',
        camporelacao: 'descricao',
        entidade:     'routerboard.entidade',
        template:     'routerboard.template',
    },
    tipolog: {
        exibir:   'main.usuariologacesso.tipolog',
        visivel:  true,
        tipo:     'enum',
        entidade: 'usuariologacesso.tipolog',
    },
    datalog: { exibir: 'main.usuariologacesso.datalog', visivel: true, tipo: 'date', time: true },
    ip:                  { exibir: 'main.usuariologacesso.ip',                  visivel: true, validacao: { obrigatorio: true } },
    mac:                 { exibir: 'main.usuariologacesso.mac',                 visivel: true, validacao: { obrigatorio: true } },
    ipconcentrador:      { exibir: 'main.usuariologacesso.ipconcentrador',      validacao: { obrigatorio: true } },
    dispositivo: {
        exibir:   'main.usuariologacesso.dispositivo',
        entidade: 'usuariologacesso.dispositivo',
        tipo:     'enum',
    },
    provedor: {
        exibir:   'main.usuariologacesso.provedor',
        entidade: 'usuarioprovedor.provedor',
        tipo:     'enum',
    },
    os:     { exibir: 'main.usuariologacesso.os' },
    modelo: { exibir: 'main.usuariologacesso.modelo' },
    // Oculto na grid por padrão (disponível no configurador) — exibido apenas no formulário.
    homologacao: { exibir: 'main.usuariologacesso.homologacao', tipo: 'boolean', template: 'homologacao.template' },
    // tempologin/uptime: ocultos na grid por padrão (disponíveis no configurador) — valores brutos
    // por registro, para avaliação manual futura (ver especificação 123). No formulário usam
    // ModelTempo (ver especificação 126) — na prática só aparecem em "Ver" (logs são gerados pelo
    // webhook da Routerboard, não editados manualmente), mas o componente continua editável.
    tempologin: { exibir: 'main.usuariologacesso.tempologin', tipo: 'numeric', template: 'tempologin.template' },
    uptime:     { exibir: 'main.usuariologacesso.uptime',     tipo: 'numeric', template: 'uptime.template' },
    // bytesin/bytesout: só preenchidos em eventos de desconexão (ver especificação 119) — mesmo
    // par de campos já usado em UsuarioSessao.
    bytesin:  { exibir: 'main.usuariologacesso.bytesin',  tipo: 'bytes' },
    bytesout: { exibir: 'main.usuariologacesso.bytesout', tipo: 'bytes' },
};

// ─── Renderers customizados ───────────────────────────────────────────────────

const booleanTemplate = (campo) => (rowData) => (
    <i className={`pi ${rowData[campo] ? 'pi-check text-green-500' : 'pi-times text-red-400'}`}></i>
);

const renderers = {
    usuario:     { entidade: Usuario,     template: (rowData) => rowData.usuario?.nome || rowData.usuario?.id || '' },
    routerboard: { entidade: Routerboard, template: (rowData) => rowData.routerboard?.descricao || '' },
    'usuariologacesso.tipolog':      UsuarioLogTipologEnum,
    'usuariologacesso.dispositivo':  UsuarioLogDispositivoEnum,
    'usuarioprovedor.provedor':      UsuarioProvedorEnum,
    homologacao: { template: booleanTemplate('homologacao') },
    tempologin: { template: (rowData) => (rowData.tempologin > 0 ? UtilService.formatarDuracaoCurta(rowData.tempologin) : '—') },
    uptime:     { template: (rowData) => (rowData.uptime > 0 ? UtilService.formatarDuracaoCurta(rowData.uptime * 1000) : '—') },
};

// ─── Formulário de campos (render prop) ───────────────────────────────────────

class UsuarioLogFormulario extends Component {
    render() {
        const { model, contexto } = this.props;
        return (
            <div className="grid">
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={model.usuario} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={model.routerboard} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelDropDown model={model.tipolog} contexto={contexto} />
                </div>
                 <div className="field col-12 md:col-4 mt-3">
                    <ModelCalendar model={model.datalog} contexto={contexto} />
                </div>                
                <div className="field col-12 md:col-4 mt-3">
                    <ModelDropDown model={model.provedor} contexto={contexto} />
                </div>
               
                <div className="field col-12 md:col-4 mt-3">
                    <ModelTextInput model={model.ip} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelTextInput model={model.mac} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelTextInput model={model.ipconcentrador} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelDropDown model={model.dispositivo} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelTextInput model={model.os} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelTextInput model={model.modelo} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelTempo model={model.tempologin} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelTempo model={model.uptime} contexto={contexto} unidade="segundos" />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelInputBytes model={model.bytesin} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelInputBytes model={model.bytesout} contexto={contexto} />
                </div>
            </div>
        );
    }
}

// ─── Template (componente exportado) ─────────────────────────────────────────

class UsuarioLogTemplate extends Component {

    processos() {
        return [{
            label:    'main.duplicar',
            icon:     'pi pi-clone',
            disabled: true,
            ativo: (processo, selected) => {
                processo.disabled = selected.length !== 1;
                return processo;
            },
            command: () => { this.gridRef?.duplicar(); },
        }];
    }

    render() {
        return (
            <EntityGrid
                ref={(ref) => this.gridRef = ref}
                entidade={UsuarioLog}
                model={model}
                identidade="main.usuariologacesso"
                permissoes={this.props.permissoes}
                icone="pi-list"
                storageKey="dt-usuariologs"
                processos={this.processos()}
                relacionados={[]}
                renderers={renderers}
                configuracao={this.props.configuracao}
                ordenacaoPadrao={{ sortField: 'datalog', sortOrder: -1 }}
                formulario={(m, ctx) => <UsuarioLogFormulario model={m} contexto={ctx} />}
            />
        );
    }
}

export default UsuarioLogTemplate;
